module.exports = __webpack_public_path__ + "static/media/gardenTongueAndGroove.f57df61c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gardenTongueAndGroove.jpg
// module id = 172
// module chunks = 0